import { OnEvent, Service } from '@toeverything/infra';

import { UserCopilotQuota } from '../entities/user-copilot-quota';
import { UserCopilotQuotaStore } from '../stores/user-copilot-quota';
import { AccountChanged } from './auth';

@OnEvent(AccountChanged, e => e._onAccountChanged)
export class UserCopilotQuotaService extends Service {
  copilotQuota = this.framework.createEntity(UserCopilotQuota);

  _onAccountChanged() {
    this.copilotQuota.revalidate();
  }

  async fetchMonthlyTranscriptionUsage(
    period?: string,
    abortSignal?: AbortSignal
  ) {
    return this.framework
      .get(UserCopilotQuotaStore)
      .fetchMonthlyTranscriptionUsage(period, abortSignal);
  }

  async reportMonthlyTranscriptionUsage(
    deltaSeconds: number,
    period?: string,
    abortSignal?: AbortSignal
  ) {
    return this.framework
      .get(UserCopilotQuotaStore)
      .reportMonthlyTranscriptionUsage(deltaSeconds, period, abortSignal);
  }
}
